<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <b-row>
            <b-col md="4">
              <b-form-group label="Libellé" label-for="libelle">
                <b-form-input
                  id="libelle"
                  type="text"
                  :class="{hasError: errors.libelle !== ''}"
                  v-model="libelle"
                />
                <span class="field-error">{{ errors.libelle }}</span>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Type" label-for="type">
                <b-form-input
                  id="type"
                  type="text"
                  :class="{hasError: errors.type !== ''}"
                  v-model="type"
                />
                <span class="field-error">{{ errors.type }}</span>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <span v-b-tooltip.hover.lefttop="{ customClass: 'pre-formatted' }"
                         :title="getTooltip()"
                         id="tooltip-note">
                <img style="margin-top: 7%" class="clickable" :src="getIconSrc()" @click="editCommentaire()"/>
              </span>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md-12>
        <b-card no-body>
          <div class="card-smallHeader card-header-action" v-b-toggle.collapse-list-siren>
            <span><strong>Liste des siren du groupe</strong></span>
            <div class="card-header-actions">
              <span class="when-opened"><i class="icon-arrow-down"></i></span>
              <span class="when-closed"><i class="icon-arrow-up"></i></span>
            </div>
          </div>
          <b-collapse id="collapse-list-siren" :visible="true">
            <b-card-body class="small-padding">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th class="center" rowspan="2"><b>SIREN</b></th>
                  <th class="center" rowspan="2"><b>Raison Sociale</b></th>
                  <th class="center" rowspan="2"><b>Gamme Produits</b></th>
                  <th class="center" rowspan="2"><b>Date<br>d'effet</b></th>
                  <th class="center" colspan="3"><b>Nb Salariés</b></th>
                </tr>
                <tr>
                  <th class="center" width="12%"><b>Cadres</b></th>
                  <th class="center" width="12%"><b>Non-Cadres</b></th>
                  <th class="center" width="12%"><b>Autres</b></th>
                </tr>
                </thead>
                <tbody v-if="dataIsReady">
                <tr v-for="(element, key) in firstSirenTable" :key="key">
                  <td><a href="#" @click.prevent="fiche(key, element.RaisonSociale)">{{ key }}</a></td>
                  <td>
                <span>
                  <a href="#" @click.prevent="fiche(key, element.RaisonSociale)">
                      {{ element.RaisonSociale ? element.RaisonSociale.substring(0,42) : '' }}
                      (OAG : <span style="color: #ff0032">{{ element.oag }} </span>  OAP : <span style="color: #ffa434">{{ element.oap }} </span>)
                    </a>
                  <i v-if="element.RaisonSociale && element.RaisonSociale.length > 42"
                     class="fa fa-question-circle pull-right"
                     v-b-tooltip.hover
                     :title="element.RaisonSociale">
                    </i>
                </span>
                  </td>
                  <td>{{getGammeProduit(element.GammeProduit)}}</td>
                  <td class="center">{{formatDate(element.DateEffet)}}</td>
                  <td class="center">{{element.Cadre || '-' }}</td>
                  <td class="center">{{element.NonCadre || '-' }}</td>
                  <td class="center">{{element.Autre || '-' }}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <td class="prune-medium"><b>TOTAL</b></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="center" colspan="3"><b> {{ NbTotalSal }} salarié(s)</b></td>
                </tr>
                </tfoot>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <div class="card-smallHeader card-header-action" v-b-toggle.collapse-contacts-commerciaux>
            <span><strong>Liste des contacts commerciaux du groupe</strong></span>
            <div class="card-header-actions">
              <span class="when-opened"><i class="icon-arrow-down"></i></span>
              <span class="when-closed"><i class="icon-arrow-up"></i></span>
            </div>
          </div>
          <b-collapse id="collapse-contacts-commerciaux" :visible="true">
            <b-card-body>
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>DR</th>
                  <th>SIREN</th>
                  <th>Raison Sociale</th>
                  <th>Segment Commercial</th>
                  <th>Segment Gestion</th>
                  <th class="center">Voir contact</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(element, key) in secondSirenTable" :key="key">
                  <td>{{ element.delegation_commercial }}</td>
                  <td>{{ element.siren }}</td>
                  <td>
                  <span>{{ element.raison_sociale.substring(0,42) }}
                    <i v-if="element.raison_sociale.length > 42"
                       class="fa fa-question-circle pull-right"
                       v-b-tooltip.hover
                       :title="element.raison_sociale">
                    </i>
                  </span>
                  </td>
                  <td>{{ element.segment_commercial }}</td>
                  <td>{{ element.segment_gestion }}</td>
                  <td class="center">
                    <b-button title="voir contact" type="enter" @click.prevent="fiche(element.siren, element.raison_sociale, 'contact')" size="sm" variant="primary">
                      <i class="fa fa-search"></i>
                    </b-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <div class="card-smallHeader card-header-action" v-b-toggle.collapse-attach-siren>
            <span><strong>Attacher siren au groupe</strong></span>
            <div class="card-header-actions">
              <span class="when-opened"><i class="icon-arrow-down"></i></span>
              <span class="when-closed"><i class="icon-arrow-up"></i></span>
            </div>
          </div>
          <b-collapse id="collapse-attach-siren">
            <b-card-body>
              <div class="flex-box">
                <b-form-group class="child--featured">
                  <b-form-input
                    placeholder="Raison Sociale"
                    id="raison"
                    type="text"
                    :class="{hasError: errors.raisonSociale !== ''}"
                    v-model="raisonSociale"
                  />
                </b-form-group>
                <b-button
                  class="search-btn"
                  type="button"
                  @click="search"
                  size="sm"
                  variant="primary">
                  Recherche
                </b-button>
              </div>
              <div class="p-2">
                <b-form-group v-if="sirensReady">
                  <b-form-checkbox-group class="pl-3" v-model="checkedSirens">
                    <b-row>
                      <b-form-checkbox v-for="siren in sirens"
                                       :value="siren.libelle"
                                       :key="siren.id">
                        {{ siren.libelle }} ({{ siren.raisonSociale }})
                      </b-form-checkbox>
                    </b-row>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <b-form-group>
                <label for="sirenList"><strong>SIREN(s) : </strong></label>
                <b-form-textarea id="sirenList"
                                 v-model="sirenList"
                                 placeholder="Entrer siren séparé par ;">
                </b-form-textarea>
              </b-form-group>
              <div class="mt-5" slot="footer">
                <b-button type="button" @click="returnBack" size="md" variant="secondary">
                  <i class="fa fa-arrow-left"/> Liste des groupes
                </b-button>
                <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
                  <i class="fa fa-save"/> Enregistrer
                </b-button>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-modal size="xl" scrollable id="modal-commentaire" ref="modal-commentaire" title="Commentaires">
      <b-row v-for="(commentaire,key) of commentairesGroupeSiren" class="align-items-center" :key="commentaire.id">
        <b-col md="10" style="display: inline-block;">
          <label>Commentaire
            <span class="smaller-2">
              <i>Dernière modification le {{ formatDateHeure(commentaire.updated_at) }} par {{ commentaire.gestionnaire.prenom }} {{ commentaire.gestionnaire.nom }}</i>
            </span>
          </label>
          <b-form-textarea
            :id="'commentaire-'+commentaire.id"
            v-model="commentaires[commentaire.id].texte"
            placeholder="Saisir un commentaire..."
            rows="3"
            max-rows="6"
            :class="{hasError: errors.commentaire !== '' && commentaires[commentaire.id].texte === ''}">
          </b-form-textarea>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <button v-if="addComHidden" type="button" title="Ajouter un commentaire"
                  class="btn btn-succes mr-1  pull-right" @click="addComHidden = false"><i
            class="fa fa-plus-circle fa-2x green" aria-hidden="true"></i></button>
        </b-col>
      </b-row>
      <b-row v-if="!addComHidden">
        <b-col md="10">
          <b-card no-body class="mt-3">
            <div class="card-smallHeader">
              <i class="fa fa-justify mr-2"></i>
              <strong>Ajouter un commentaire</strong>
            </div>
            <b-card-body>
              <b-form-group>
                <b-form-textarea
                  v-model="commentaireToAdd"
                  placeholder="Saisir un commentaire..."
                  rows="3"
                  max-rows="6"
                  :class="{hasError: errors.commentaire !== '' && commentaireToAdd === ''}">
                </b-form-textarea>
              </b-form-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <span class="field-error inline mr-1 float-right">{{ errors.commentaire }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal()">Annuler</button>
          <button type="button" @click="saveCommentaire()" class="btn btn-primary"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "Detail",
    data() {
      return {
        firstSirenTable: [],
        secondSirenTable: [],
        sirenList: '',
        sirens: [],
        raisonSociale: '',
        sirensReady: false,
        checkedSirens: [],
        id: "",
        libelle: "",
        type: "",
        dataIsReady: false,
        errors: {
          libelle: "",
          type: "",
          groupe: "",
          sirenList: '',
          raisonSociale: "",
          commentaire: "",
        },
        commentaires: [],
        commentairesGroupeSiren: [],
        commentairesOriginaux: [],
        addComHidden: true,
        commentaireToAdd: '',
      }
    },
    computed: {
      NbTotalSal() {
        let result = 0;
        for (let index in this.firstSirenTable) {
          if (this.firstSirenTable[index]['Cadre'] !== '-' && !isEmpty(this.firstSirenTable[index]['Cadre'])) {
            result += this.firstSirenTable[index]['Cadre'];
          }
          if (this.firstSirenTable[index]['NonCadre'] !== '-' && !isEmpty(this.firstSirenTable[index]['NonCadre'])) {
            result += this.firstSirenTable[index]['NonCadre'];
          }
          if (this.firstSirenTable[index]['Autre'] !== '-' && !isEmpty(this.firstSirenTable[index]['Autre'])) {
            result += this.firstSirenTable[index]['Autre'];
          }
        }
        return result;
      },
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getGroupSiren();
    },
    mounted() {
      // this.concatCheckedSirens();
    },
    methods: {
      getGroupSiren() {
        let id = this.$route.params.id;
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/groupes-siren/" + id)
          .then(response => {
            this.id = response.data.groupSiren.id;
            this.libelle = response.data.groupSiren.libelle;
            this.type = response.data.groupSiren.type;
            this.firstSirenTable = response.data.firstTable;
            this.secondSirenTable = response.data.secondTable;
            this.dataIsReady = true;
            this.commentairesGroupeSiren = response.data.groupSiren.commentaire_groupe_siren;
            this.setCommentaires(this.commentairesGroupeSiren);

            this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            this.$store.commit('IS_LOADING', false);
            if (error.response && error.response.status === 404 && self != undefined) {
              this.$swal({
                position: 'top',
                type: 'warning',
                title: 'Attention !!',
                text: `Le groupe avec l'id ${id} n'existe pas`,
                showConfirmButton: false,
                timer: 5000
              });
              this.$router.push({path: '/espace-gestion/groupes-siren'})
            }
          });
      },
      edit() {
        // console.log('dans le edit')
        const id = this.$route.params.id;
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.id = this.id;
          dataPost.type = this.type;
          dataPost.sirens = this.concatCheckedSirens();
          dataPost.insertedSirens = this.getInsertedSirens();
          this.$axios
            .put("/espaceQualite/groupes-siren/edit/" + id, dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "Le groupe SIREN a été bien modifié ",
                showConfirmButton: false,
                timer: 5000
              });
              // this.returnBack();
            })
            .catch(() => {
              this.handleErrors();
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/groupes-siren"});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.libelle === "") {
          this.errors.libelle = "Le libellé est obligatoire";
          valid = false;
        }
        if (this.type === "") {
          this.errors.type = "Le type est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = "";
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter un administrateur',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      search() {
        this.sirens = [];
        if (this.raisonSociale !== '') {
          this.$store.commit("IS_LOADING", true);
          const dataPost = {
            raison_sociale: this.raisonSociale,
          };
          this.$axios
            .post("/espaceQualite/sirens", dataPost)
            .then((response) => {
              this.$store.commit("IS_LOADING", false);
              const sirens = response.data.sirens;
              if (sirens.length > 0) {
                this.sirensReady = true;
                for (let i = 0; i < sirens.length; i++) {
                  this.sirens.push({
                    id: sirens[i].id,
                    libelle: sirens[i].siren,
                    raisonSociale: sirens[i].raison_sociale,
                  });
                }
              }
            })

        }
      },
      concatCheckedSirens() {
        //return this.firstSirenTable.map(({id}) => id).concat(this.checkedSirens);
        var firstSirenTable = this.firstSirenTable;
        var keys = Object.keys(firstSirenTable).map(key => key);
        return keys.concat(this.checkedSirens);
      },
      removeSiren(id) {
        this.firstSirenTable = this.firstSirenTable.filter(element => element.id !== id);
      },
      getInsertedSirens() {
        let listSiren = this.sirenList.replace(',',';');
        listSiren = listSiren.replace(' ','');

        return listSiren.split(';').filter(element => element.trim() !== '');
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      getGammeProduit(produits = []) {
        return [...new Set(produits)].join();
      },
      fiche(siren, raison_sociale, onglet = null) {
        let query = {
          sir: siren,
          rs: raison_sociale,
        }
        if(onglet !== null) {
          query.onglet = onglet;
        }
        this.$router.push({path: "/espace-gestion/sirens/fiche/" + siren, query: query});
      },
      editCommentaire() {
        this.$refs['modal-commentaire'].show();
        /*
        this.commentairesGestion = dossier.commentaires_gestion;
         */
      },
      saveCommentaire() {
        if (this.validateCommentaires()) {
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post(`/espaceQualite/groupes-siren/add-comment/${this.id}`, {
              'commentaire': this.commentaireToAdd,
            })
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              this.closeModal();
              this.commentairesGroupeSiren = response.data.data;
              this.setCommentaires(this.commentairesGroupeSiren);
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: 'Commentaire bien enregistré',
                showConfirmButton: false,
                timer: 3000
              });
            })
            .catch(function (error) {
              console.log(error);
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
              if (error.response.status === 400) {
                textError = 'Vous devez saisir un commentaire';
              }
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: textError,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      closeModal() {
        this.$refs['modal-commentaire'].hide();
        this.remiseAZero();
      },
      remiseAZero() {
        this.addComHidden = true;
        this.commentaireToAdd = '';
        this.commentairesGroupeSiren = [];
        this.clearErrors();
      },
      validateCommentaires() {
        let error = false;
        for (let commentaireKey in this.commentaires[this.id]) {
          if (commentaireKey === undefined) {
            continue;
          }
          if (this.commentaires[this.id][commentaireKey].texte === '') {
            error = true;
            this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
          }
        }
        if (this.commentaireToAdd.trim() === '') {
          error = true;
          this.errors.commentaire = 'Vous ne pouvez pas enregistrer un commentaire vide';
        }
        return !error;
      },
      getTooltip() {
        let tooltip = '';
        for (let element of this.commentairesGroupeSiren) {
          if(!isEmpty(element)) {
            tooltip = tooltip + element.commentaire + '\n';
          }
        }
        return tooltip;
      },
      setCommentaires(allComments) {
        this.commentaires = [];
        this.commentairesOriginaux = [];
        for (let element of allComments) {
          if(!isEmpty(element)) {
            this.commentaires[element.id] = {
              texte: element.commentaire,
            }
            this.commentairesOriginaux[element.id] = {
              texte: element.commentaire,
            }
          }
        }
      },
      getIconSrc() {
        const images = require.context('@/assets/images/', false, /\.png$/);
        const icon = this.commentairesGroupeSiren.length === 0 ? 'post-it-no-note-26.png' : 'post-it-normal-26.png';
        return images('./' + icon);
      },
      formatDateHeure(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
      },
    }
  }
</script>
<style scoped>
  .pre-formatted {
    white-space: pre-line;
    max-width: 100% !important;
  }

  .center, td.center, th.center {
    text-align: center;
  }

  .right, td.right, th.right {
    text-align: right;
  }

  @media screen and (max-width: 1910px) {
    .siren-list {
      overflow-y: scroll;
      height: 200px;
    }
  }

  .flex-box {
    display: flex;
    justify-content: space-between;
  }

  .search-btn {
    margin-bottom: 1rem;
  }

  .child--featured {
    flex-basis: 80%;
  }
</style>
